/* eslint-disable no-shadow */
import {
  getLeads2,
  markLeadStatus,
  getLeadsStates,
  saveContactStatus,
  getPublisherData
} from '../../../apiclient/resources/leads';
import { InboxOperations } from '../../menuInbox/ducks';
import { FilterStatusOperations } from '../../filterStatus/ducks';
import * as actions from './actions';
import { getQuerySringFilters } from './utils';
import { getMessage } from '../../../services/utils/leads';

const fetchLeadBackground = (lead, contactIds) => dispatch => {
  const { table, filterStatus, inbox, postingFiltered } = lead;
  const total = table.paging.total - contactIds.length;
  let { offset } = table.params;
  if (table.paging.offset > 0 && total <= table.paging.offset) {
    offset -= table.paging.limit;
  }
  getLeads2(getQuerySringFilters({ ...table.params, offset })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.updateLeadsSucceededBackground(data));
      if (filterStatus.filtersSelected.length > 0) {
        dispatch(FilterStatusOperations.getLeadsCounter(inbox.status, postingFiltered.id));
      }
    }
  });
};

const fetchLeads = () => (dispatch, getState) => {
  const { lead } = getState();
  dispatch(actions.fetchLeads({ ...lead.table.params, limit: 20 }));
  getLeads2(getQuerySringFilters({ ...lead.table.params, limit: 20 })).then(({ error, data }) => {
    if (error) {
      dispatch(actions.fetchLeadsFailed(error));
    } else {
      dispatch(actions.fetchLeadsSucceeded(data));
      // eslint-disable-next-line no-unused-vars
      getLeadsStates().then(({ error, data }) => {
        dispatch(actions.fetchLeadsStatus(data));
      });

      getPublisherData().then(({ error, data }) => {
        // eslint-disable-next-line no-unused-vars
        dispatch(actions.fetchPublisherSucceeded(data));
      });
    }
  });

  dispatch(actions.fetchLeadsOther({ ...lead.table.paramsOther, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsOther, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsOther(data));
    }
  });

  dispatch(actions.fetchLeadsPhoneCall({ ...lead.table.paramsPhoneCall, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsPhoneCall, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsPhoneCall(data));
    }
  });

  dispatch(actions.fetchLeadsWh({ ...lead.table.paramsWhatsapp, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsWhatsapp, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsWh(data));
    }
  });

  dispatch(actions.fetchLeadsEmails({ ...lead.table.paramsEmails, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsEmails, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsEmails(data));
    }
  });
};

const fetchLeadsChangueStatus = (data, id) => dispatch => {
  saveContactStatus(data, id).then(({ error, data }) => {
    if (error) {
      dispatch(actions.fetchLeadsUpdateStatusFailed(data));
    }
  });
};

const fetchLeadsMobileEvent = () => dispatch => {
  dispatch(actions.fetchLeadsMobileSucceededEvent({}));
};

const fetchLeadChangueFilterFeedback = () => dispatch => {
  dispatch(actions.changeFilter({}));
};

const fetchLeadsMobile = () => (dispatch, getState) => {
  const { lead } = getState();
  dispatch(actions.fetchLeadsMobile({ ...lead.table.params, limit: 20 }));
  getLeads2(getQuerySringFilters({ ...lead.table.params, limit: 20 })).then(({ error, data }) => {
    if (error) {
      dispatch(actions.fetchLeadsFailed(error));
    } else {
      dispatch(actions.fetchLeadsMobileSucceeded(data));
    }
  });

  dispatch(actions.fetchLeads({ ...lead.table.paramsOther, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsOther, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsOther(data));
    }
  });

  dispatch(actions.fetchLeads({ ...lead.table.paramsPhoneCall, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsPhoneCall, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsPhoneCall(data));
    }
  });

  dispatch(actions.fetchLeads({ ...lead.table.paramsWhatsapp, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsWhatsapp, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsWh(data));
    }
  });

  dispatch(actions.fetchLeads({ ...lead.table.paramsEmails, limit: 2 }));
  getLeads2(getQuerySringFilters({ ...lead.table.paramsEmails, limit: 2 })).then(({ error, data }) => {
    if (!error) {
      dispatch(actions.fetchLeadsEmails(data));
    }
  });
};

const updateStatusByLead = lead => dispatch => {
  const leadStatus = lead.isFavorite ? 'NONFAVORITE' : 'FAVORITE';
  dispatch(actions.updateLeadStatusFavorite({ leadStatus, contact_publisher_user_id: lead.contact_publisher_user_id }));
  markLeadStatus(leadStatus, lead.contact_publisher_user_id).then(({ error }) => {
    if (!error) {
      dispatch(actions.updateLeadStatusFavoriteSucceeded(lead));

      dispatch(
        actions.showSnackBar({
          key: `${lead.contact_publisher_user_id}${leadStatus}`,
          message: getMessage(1, leadStatus),
          count: 1,
          show: true
        })
      );
    } else {
      dispatch(actions.updateLeadStatusFavoriteFailed(lead));

      dispatch(
        actions.showSnackBar({
          key: `${lead.contact_publisher_user_id}`,
          message: 'contactos:snackBar.errorMesasge',
          show: true,
          isError: true
        })
      );
    }
  });
};

const updateStatusOfSelectedLeads = (leadStatus, isMobile, reason) => (dispatch, getState) => {
  const { lead } = getState();
  const contactIds = lead.table.leads.filter(l => l.isSelected).map(l => l.contact_publisher_user_id);
  const numberOfSelecteds = contactIds.length;
  dispatch(actions.updateLeadStatus(contactIds));
  markLeadStatus(leadStatus, contactIds.toString(), reason).then(({ error }) => {
    if (!error) {
      if (leadStatus === 'READ' || leadStatus === 'UNREAD') {
        dispatch(InboxOperations.fetchUnread(lead.inbox.status, isMobile));
      }
      if (
        leadStatus === 'SPAM' ||
        leadStatus === 'DISCARDED' ||
        leadStatus === 'NONDISCARDED' ||
        (lead.inbox.state.favorite.active && leadStatus === 'NONFAVORITE')
      ) {
        dispatch(InboxOperations.fetchUnread(lead.inbox.status, isMobile));
        if (isMobile) {
          dispatch(actions.updateLeadStatusMobileSucceeded({ contactIds, leadStatus }));
        } else {
          fetchLeadBackground(lead, contactIds)(dispatch);
        }
      } else {
        dispatch(actions.updateLeadStatusSucceeded({ contactIds, leadStatus }));
      }
      dispatch(
        actions.showSnackBar({
          key: `${contactIds.toString()}${leadStatus}`,
          message: getMessage(numberOfSelecteds, leadStatus),
          count: numberOfSelecteds,
          show: true
        })
      );
    } else {
      dispatch(actions.updateLeadStatusFailed(error));
      dispatch(
        actions.showSnackBar({
          key: `${contactIds.toString()}`,
          message: 'contactos:snackBar.errorMesasge',
          show: true,
          isError: true
        })
      );
    }
  });
};

const changeTab = data => dispatch => {
  dispatch(actions.changeTabOption(data));
};

const updateTab = data => dispatch => {
  dispatch(actions.updateTabOption(data));
};

const updateNew = data => dispatch => {
  dispatch(actions.updateTabNew(data));
};

const updateDisplay = data => dispatch => {
  dispatch(actions.updateTabDisplay(data));
};

const updateNewFalse = data => dispatch => {
  dispatch(actions.updateTabNewFalse(data));
};
const resetTab = data => dispatch => {
  dispatch(actions.resetTabOption({}));
};

export const {
  selectedLead,
  changePage,
  showSnackBar,
  hideSnackBar,
  updateLeadStatusSucceeded,
  notShowLoading,
  changeTabOption,
  resetTabOption,
  updateTabOption,
  updateTabNew,
  updateTabNewFalse,
  updateTabDisplay
} = actions;

export {
  fetchLeads,
  fetchLeadsMobileEvent,
  fetchLeadsMobile,
  updateStatusByLead,
  changeTab,
  resetTab,
  updateTab,
  updateNew,
  updateNewFalse,
  updateDisplay,
  updateStatusOfSelectedLeads,
  fetchLeadsChangueStatus,
  fetchLeadChangueFilterFeedback
};
